import {
  TableContainerProps,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

import { BalancesResponse } from "../../../api/useGetBalances";
import { balancesEnumToLabel } from "../../../utils/balancesEnumToLabel";
import { getCurrencyValue } from "../../CallAlertsAuxWindow/auxUtils";

export interface BalancesTableProps extends TableContainerProps {
  balancesData: BalancesResponse;
}

export const BalancesTable = ({ balancesData }: BalancesTableProps) => {
  const tradeTotal = balancesData
    ? Object.values(balancesData)?.reduce(
        (acc, curr) =>
          acc + curr?.reduce((acc, curr) => acc + curr.tradeBalance, 0),
        0
      )
    : 0;

  const settledTotal = balancesData
    ? Object.values(balancesData)?.reduce(
        (acc, curr) =>
          acc + curr?.reduce((acc, curr) => acc + curr.settleBalance, 0),
        0
      )
    : 0;

  return (
    <>
      <Thead>
        <Tr>
          <Th>Type</Th>
          <Th isNumeric>Trade</Th>
          <Th isNumeric>Settled</Th>
        </Tr>
      </Thead>
      <Tbody data-testid="balances-table">
        {balancesData &&
          Object.entries(balancesData).map(([name, b]) => {
            return b.map((bal, i) => {
              return (
                <Tr>
                  <Td>{balancesEnumToLabel(name)}</Td>
                  <Td
                    isNumeric
                    data-testid={`balance-${name}-trade-${
                      i + 1
                    }`.toLocaleLowerCase()}
                  >
                    {getCurrencyValue(bal.tradeBalance)}
                  </Td>
                  <Td
                    isNumeric
                    data-testid={`balance-${name}-settled-${
                      i + 1
                    }`.toLowerCase()}
                  >
                    {getCurrencyValue(bal.settleBalance)}
                  </Td>
                </Tr>
              );
            });
          })}
        <Tr>
          <Td fontWeight="bold" borderBottom="0">
            Totals
          </Td>
          <Td
            isNumeric
            data-testid="balance-total-trade"
            fontWeight="bold"
            borderBottom="0"
          >
            {getCurrencyValue(tradeTotal, 2)}
          </Td>
          <Td
            isNumeric
            data-testid="balance-total-settled"
            fontWeight="bold"
            borderBottom="0"
          >
            {getCurrencyValue(settledTotal, 2)}
          </Td>
        </Tr>
      </Tbody>
    </>
  );
};
